import { Component, ViewChild } from '@angular/core';
import { NgxWheelComponent, TextOrientation, TextAlignment } from 'ngx-wheel';
import { SharedService } from './shared.service';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  @ViewChild(NgxWheelComponent, { static: false }) wheel;

  seed = [];
  id: any;
  idToLandOn: any;
  items: any[] = [];
  textOrientation: TextOrientation = TextOrientation.HORIZONTAL
  textAlignment: TextAlignment = TextAlignment.INNER;
  isWheel: boolean = false;
  isRegister: boolean = true;
  isSuccess: boolean = false;
  registrationForm: any;
  submitted = false;
  isRegistered: boolean = false;
  btText: any = 'Submit';
  wonPrize: any = '';

  constructor(private spinService: SharedService,
    public fb: FormBuilder) {
    this.registrationForm = this.fb.group({
      fullName: new FormControl('', Validators.required),
      mobileNumber: new FormControl('', [Validators.required]),
      emailId: new FormControl('', [Validators.required, Validators.email]),      
      customerLocation: new FormControl('', [Validators.required]),
    })
  }

  ngOnInit() {
  }

  getAllPrizes() {

    this.spinService.getAllPrizes()
      .subscribe(
        (data) => {
          this.seed = data;
          const colors = ['#fe0e73', '#1a95ff', '#ffeb1c', '#ffcc0f', '#fc9512', '#b5b5b5', '#00cba2', '#7815fc'];

          let result = [];
          for (let i = 0; i < this.seed.length; i++) {
            result.push(colors[i % colors.length]);
          }

          this.items = this.seed.map((value, index) => ({
            fillStyle: result[(index)],
            text: value.prizeName,
            id: value.id,
            textFillStyle: 'white',
            textFontSize: '12'
          }));
          this.isWheel = true;
          this.isRegister = false;
          this.isSuccess = false;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  reset() {
    this.wheel.reset()
  }

  async spin(prize) {
    this.idToLandOn = prize
    await new Promise(resolve => setTimeout(resolve, 0));
    this.wheel.spin();
  }

  after() {
    this.spinService.spin(this.id)
      .subscribe(
        (data) => {
          this.isWheel = false;
          this.isRegister = false;
          this.isSuccess = true;
        },
        (error) => {
          console.log(error);
        })
  }

  register() {
    this.submitted = true;
    if (!this.registrationForm.valid)
      return;
    else
      this.btText = 'Loading..'

    this.spinService.register(this.registrationForm.value)
      .subscribe(
        (data) => {
          this.btText = 'Submit';
          if (data == 'Already Registered')
            this.isRegistered = true;
          else {
            this.idToLandOn = data.prize.id;
            this.id = data.id;
            this.wonPrize = data.prize.prizeDescription;
            this.getAllPrizes();
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  before() {
  }

}
